import { WorkflowRecord } from "./WorkflowRecord";
import { IsoDateTime } from "app/pseudo-types/DateTypes";

export type WorkflowViewModels = ReadonlyArray<WorkflowViewModel>;

export class WorkflowViewModel implements WorkflowRecord {

  private constructor(private readonly record: WorkflowRecord) {
  }

  public get id(): number {
    return this.record.id;
  }

  public get portfolioId(): number {
    return this.record.portfolioId;
  }

  public get createdBy(): string {
    return this.record.createdBy;
  }

  public get lastUpdate(): IsoDateTime {
    return this.record.lastUpdate;
  }

  public get created(): IsoDateTime {
    return this.record.created;
  }

  public get noteTag(): string {
    return this.record.noteTag;
  }
  public get notes(): string {
    return this.record.notes;
  }

  public get status(): string {
    return this.record.status;
  }

  public get dueDate(): Date {
    return this.record.dueDate;
  }

  public get reminderDate(): Date {
    return this.record.reminderDate;
  }

  public get reminderRepeatValue(): number {
    return this.record.reminderRepeatValue;
  }

  public get reminderRepeatUnit(): string {
    return this.record.reminderRepeatUnit;
  }

  public static of(record: WorkflowRecord): WorkflowViewModel {
    return new WorkflowViewModel(record);
  }
}
